/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as ProductStock from './trans-website-productstoresearch-productstock';

export const Headline = 'Website.ProductStoreSearch.Headline';
export const SubHeadline = 'Website.ProductStoreSearch.SubHeadline';
export const SubHeadlineAfterSearch = 'Website.ProductStoreSearch.SubHeadlineAfterSearch';
export const SubHeadlineNoResult = 'Website.ProductStoreSearch.SubHeadlineNoResult';
export const SearchFieldLabel = 'Website.ProductStoreSearch.SearchFieldLabel';
export const SearchFieldPlaceholder = 'Website.ProductStoreSearch.SearchFieldPlaceholder';
export const UseGeoLocationButton = 'Website.ProductStoreSearch.UseGeoLocationButton';
export const SubmitButtonText = 'Website.ProductStoreSearch.SubmitButtonText';
export const GeoLocationErrorText = 'Website.ProductStoreSearch.GeoLocationErrorText';
export const SummaryCaption = 'Website.ProductStoreSearch.SummaryCaption';
export const ShowSearchButton = 'Website.ProductStoreSearch.ShowSearchButton';
export const ChooseStoreButtonText = 'Website.ProductStoreSearch.ChooseStoreButtonText';
